"use strict";

(() => {
  const wave = document.querySelector(".p-top-interview__wave");
  const side = document.querySelector(".p-top-interview__side");
  const dataBenefit = document.querySelector(".l-top-dataBenefit");

  if (!wave || !side || !dataBenefit) {
    return;
  }

  const mql = window.matchMedia("(max-width: 767px)");
  let ticking = false;

  // 波のグラデーションを Data セクション本体と同じ描画サイズに合わせる
  const updateHeight = () => {
    wave.style.setProperty(
      "--interview-wave-height",
      `${dataBenefit.offsetHeight}px`
    );
  };

  // 見出しブロックが波より上に出るまでは波を画面外へ逃がす
  const updateShift = () => {
    ticking = false;

    if (mql.matches) {
      wave.style.setProperty("--interview-wave-shift", "0px");
      return;
    }

    const bottomOffset =
      parseFloat(window.getComputedStyle(wave).insetBlockEnd) || 0;
    const stuckTop = window.innerHeight - bottomOffset - wave.offsetHeight;
    const shift = Math.max(0, side.getBoundingClientRect().bottom - stuckTop);

    wave.style.setProperty("--interview-wave-shift", `${shift}px`);
  };

  const onScroll = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    requestAnimationFrame(updateShift);
  };

  const updateAll = () => {
    updateHeight();
    updateShift();
  };

  updateAll();

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateAll);
    observer.observe(dataBenefit);
  }

  mql.addEventListener("change", updateAll);
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", updateAll, { passive: true });
  window.addEventListener("load", updateAll, { passive: true });
})();
